module.exports = "<div class=\"piechart-title\">{{ $ctrl.title }}</div>\n<nvd3\n  options=\"$ctrl.options\"\n  data=\"$ctrl.data\"\n  config=\"$crtl.config\"\n  api=\"$crtl.api\"\n  on-ready=\"$ctrl.onReady\"\n></nvd3>\n<div ng-if=\"$ctrl.avg\" class=\"piechart-title\">Avg: {{ $ctrl.avg }}</div>\n<div ng-if=\"$ctrl.count\" class=\"piechart-title\">Count: {{ $ctrl.count }}</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/components/pieChart/pieChart.html
// module id = 995
// module chunks = 0